// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, memoryLocalCache } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDE3qoD7EKo2k2C0YhFTWQuVU_2cVSv7_o",
  authDomain: "inventorysalesapp.firebaseapp.com",
  projectId: "inventorysalesapp",
  storageBucket: "inventorysalesapp.appspot.com",
  messagingSenderId: "412300547260",
  appId: "1:412300547260:web:581f85445b5046db792cb9",
};

const app = initializeApp(firebaseConfig);

// v12: use memory cache; pick ONE long-polling option (start with auto-detect)
const db = initializeFirestore(app, {
  localCache: memoryLocalCache(),
  experimentalAutoDetectLongPolling: true, // ✅ keep this
  // experimentalForceLongPolling: true,  // ❌ leave OFF unless auto-detect fails
});

const auth = getAuth(app);

// (optional) expose for console in dev only
if (typeof window !== "undefined" && import.meta?.env?.MODE !== "production") {
  window.firebaseDb = db;
  window.firebaseAuth = auth;
}

export { app, db, auth };
